import { api } from "@/lib/api";

async function blobError(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail || "Esportazione non riuscita"; } catch { return "Esportazione non riuscita"; }
  }
  return e?.message || "Esportazione non riuscita";
}

export async function openFile(fileId) {
  const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function downloadFile(path, params, fallbackName) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const m = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/);
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = m ? m[1] : fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) {
    throw new Error(await blobError(e));
  }
}
